import React, { PureComponent } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'
import AsyncCreatableSelect from 'react-select/async-creatable'
import MdSend from 'react-icons/lib/md/send'

import { styles, utils, translations } from 'gipsy-misc'
import { media, UserPicture } from 'gipsy-ui'
import { contact } from 'gipsy-api'
import Suggestion from './suggestion'

const propTypes = {
  onAddUsers: PropTypes.func
}

class InviteUserInput extends PureComponent {
  state = {
    selectedValues: []
  }

  transformsSuggestions = suggestions => {
    const options = []
    for (let i in suggestions) {
      options.push({
        value: suggestions[i].userId || suggestions[i].email,
        label: suggestions[i]
      })
    }
    return options
  }

  onAddUsers = async e => {
    e.stopPropagation()
    const users = this.state.selectedValues.map(v => v.label)
    try {
      await this.props.onAddUsers(users)
      this.setState({ selectedValues: [] })
    } catch (err) {}
  }

  formatOptions = object => {
    return <Suggestion contact={object.label} />
  }

  formatCreate = inputValue => {
    return { email: inputValue }
  }

  getNewOptionData = inputValue => {
    return { label: { email: inputValue }, value: inputValue }
  }

  onChange = input => {
    this.setState({ selectedValues: input })
  }

  isValidNewOption = (inputValue, selectValue, selectOptions) => {
    return selectOptions.length === 0 && utils.email.validateEmail(inputValue)
  }

  promiseOptions = async inputValue => {
    let options = []
    try {
      const contactSuggestions = (await contact.get(inputValue, true)) || []
      options = this.transformsSuggestions(contactSuggestions)
    } catch (err) {
      console.error(err)
    }
    return options
  }

  render() {
    return (
      <InviteUser>
        <AsyncCreatableSelect
          isMulti
          placeholder={translations.suggestions.person.placeholder}
          formatOptionLabel={this.formatOptions}
          formatCreateLabel={this.formatCreate}
          styles={{
            multiValue: base => ({ ...base, height: '40px', borderRadius: '18px', backgroundColor: 'white' }),
            multiValueRemove: base => ({ ...base, cursor: 'pointer' }),
            control: base => ({
              ...base,
              backgroundColor: '#EBEAEE',
              minHeight: '56px',
              maxHeight: '130px',
              borderRadius: '22px',
              display: 'flex',
              flexDirection: 'row',
              overflow: 'auto',
              borderWidth: '0px'
            }),
            placeholder: base => ({
              ...base,
              font: styles.fonts.primaryFont,
              fontSize: styles.fonts.fontSizeSmall,
              paddingLeft: '2px'
            })
          }}
          components={{ Control, DropdownIndicator, MultiValueLabel }}
          onChange={this.onChange}
          onAddUsers={this.onAddUsers}
          loadOptions={this.promiseOptions}
          defaultOptions
          isValidNewOption={this.isValidNewOption}
          getNewOptionData={this.getNewOptionData}
          value={this.state.selectedValues}
        />
      </InviteUser>
    )
  }
}

const Control = props => {
  return (
    <components.Control {...props} className="control">
      {props.children}
      <Button
        onMouseDown={e => props.selectProps.onAddUsers(e)}
        onTouchEnd={e => props.selectProps.onAddUsers(e)}
        className="button">
        <span>{translations.teamlist.inviteUser.popup.button}</span>
        <SendContainer classname="send-container">
          <MdSend className="md-send" />
        </SendContainer>
      </Button>
    </components.Control>
  )
}

const DropdownIndicator = props => {
  return (
    <DropdownIndicatorWrapper>
      <components.DropdownIndicator {...props} />
    </DropdownIndicatorWrapper>
  )
}

const MultiValueLabel = props => {
  return (
    <components.MultiValueLabel {...props} className="multivalue-label">
      <NameContainer className="name-container">
        <UserPicture
          backgroundColor="#e3e5e6"
          src={get(props, 'data.label.picture')}
          size={32}
          style={{ marginRight: styles.spacings.small }}
        />
        <span>{props.data.label.email}</span>
      </NameContainer>
    </components.MultiValueLabel>
  )
}

InviteUserInput.propTypes = propTypes

export default InviteUserInput
export const InviteUserInputId = 'InviteUserInput'

const InviteUser = styled.div`
  height: 88px;
  align-items: center;
  flex-wrap: wrap;
`

const NameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    color: ${styles.colors.textDarkColor};
  }
`

const SendContainer = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 14px;
  background-color: ${styles.colors.primaryColor};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 4px;
  .md-send {
    color: white;
  }
`

const Button = styled.div`
  height: 40px;
  margin: 6px;
  width: 155px;
  border-radius: 18px;
  background: ${styles.colors.backgroundPrimaryColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  ${media['phone-wide']`
    width: 40px;
    background: inherit;
    margin: 2px;
  `}
  span {
    font: ${styles.fonts.primaryFont};
    font-size: ${styles.fonts.fontSizeXSmall};
    color: white;
    ${media['phone-wide']`
    display: none;
  `}
  }
`
const DropdownIndicatorWrapper = styled.div`
  display: none;
`



// WEBPACK FOOTER //
// ./src/features/teamlist/components/inviteUserInput/index.js